import React from "react";
import { Icon } from "../numberSenseUi";
import {
  GAMES,
  TranslatorRound,
  ChordBuilderGame,
  EarRound,
  SongRound,
  PredictRound,
  TonicRound,
  CadenceRound,
} from "../NumberSenseGames";

/* ============================================================
   Number Sense — a single running practice game, wrapped in the
   shared sub-bar. The four games are self-contained and report
   XP / per-concept results back through onAward / onResults.
   ============================================================ */
const GameScreen = ({ activeGame, gameData, xp, onBack, onAward, onResults }) => {
  let body = null;
  if (activeGame === "translate") {
    body = (
      <TranslatorRound
        data={gameData}
        onExit={onBack}
        onAward={onAward}
        onResults={onResults}
      />
    );
  } else if (activeGame === "builder") {
    body = (
      <ChordBuilderGame
        data={gameData}
        onExit={onBack}
        onAward={onAward}
        onResults={onResults}
      />
    );
  } else if (activeGame === "ear") {
    body = (
      <EarRound
        data={gameData}
        onExit={onBack}
        onAward={onAward}
        onResults={onResults}
      />
    );
  } else if (activeGame === "song") {
    body = <SongRound data={gameData} onExit={onBack} onAward={onAward} />;
  } else if (activeGame === "predict") {
    body = (
      <PredictRound
        data={gameData}
        onExit={onBack}
        onAward={onAward}
        onResults={onResults}
      />
    );
  } else if (activeGame === "tonic") {
    body = <TonicRound data={gameData} onExit={onBack} onAward={onAward} />;
  } else if (activeGame === "cadence") {
    body = <CadenceRound data={gameData} onExit={onBack} onAward={onAward} />;
  }

  return (
    <div className="ns-root">
      <div className="ns-app">
        <div className="subbar">
          <button className="iconbtn" onClick={onBack} aria-label="back">
            <Icon name="back" />
          </button>
          <div className="subbar-title">
            {GAMES.find((g) => g.key === activeGame)?.sub || "game"}
          </div>
          <div className="stat xp">
            <Icon name="bolt" />
            {xp}
          </div>
        </div>
        {body}
      </div>
    </div>
  );
};

export default GameScreen;
